export default class ClientConstants 
{
    public static  IDENTITY = "https://api.flyx.cloud/bavet/identity";
    public static  CLIENT_PRIMARY_COLOR = "#DF1B20";
    public static  CLIENT_NAME = "Bavet";
    public static  CLIENT_IMAGE = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ0Z2wB0vBC109oasKUFxcNIFks0sVAw4lCzQ&usqp=CAU";
    public static ROUND_CLIENT_IMAGE = true;
}